module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.50d01d3.woff2";